<template>
    <section class="section">
        <div class="container">
            <page-header title="Leverandører">
                <button class="button is-primary" @click="openModal(null)">Opret</button>
            </page-header>
            <List
                class="table-responsive"
                table-classes="table is-fullwidth"
                :columns="columns"
                :data="listSuppliers"
                :page-length="50"
                :rows-clickable="false"
                :default-order="{ col: 'name', dir: 'asc' }"
            >
                <template slot="column-actions" slot-scope="{ row }">
                    <a class="button is-small is-light"
                       @click.stop="showItemsBySupplierId(row.id)"
                       :title="`Se vare tilknyttet ${row.name}`">
                        <span class="icon">
                            <i class="fas fa-store-alt"/>
                        </span>
                    </a>
                    <a class="button is-small" @click.stop="openModal(row.id)" title="Rediger">
                        <span class="icon">
                            <i class="fas fa-edit"/>
                        </span>
                    </a>
                </template>
            </List>
        </div>

        <SupplierModal
            v-if="modalOpen"
            :active="modalOpen"
            :supplier-id="modalSupplierId"
            @closed="closeModal"
        />
    </section>
</template>

<script>
import List from '@elems/list'
import PageHeader from '@elems/pageHeader'
import {mapGetters} from 'vuex'
import SupplierModal from './SupplierModal';

export default {
    components: {
        PageHeader,
        List,
        SupplierModal,
    },
    data() {
        return {
            columns: [
                {
                    name: 'id',
                    title: 'Leverandør nr.',
                    sortable: true,
                    searchable: true,
                    template: row => row.economic_id || row.id
                },
                { name: 'name', title: 'Navn', sortable: true, searchable: true, },
                { name: 'address', title: 'Adresse', sortable: true, searchable: true, },
                { name: 'zipcode', title: 'Post nr.', sortable: true, searchable: true, },
                { name: 'city', title: 'By', sortable: true, searchable: true, },
                {
                    name: 'country',
                    title: 'Land',
                    sortable: true,
                    searchable: true,
                    template: row => row.country ? row.country.name : '-'
                },
                { name: 'phone', title: 'Tlf', hidden: true, searchable: true, },
                {
                    name: 'actions',
                    title: '',
                    sortable: false,
                    searchable: false,
                    classes: () => 'has-text-right',
                    width: '100px'
                },
            ],
            modalOpen: false,
            modalSupplierId: false,
        }
    },
    computed: {
        ...mapGetters([
            'listSuppliers',
        ]),
    },
    methods: {
        showItemsBySupplierId(id) {
            this.$router.push({
                name: 'item.index',
                query: {
                    supplier: id,
                }
            })
        },
        openModal(customerId = null) {
            this.modalOpen = true
            this.modalSupplierId = customerId
        },
        closeModal() {
            this.modalOpen = false
            this.modalSupplierId = null
        }
    },
    created() {
        this.$store.dispatch('loadSuppliers')
    },
}
</script>
